import { motion } from 'framer-motion'
import styled from 'styled-components'

export const StyledMenu = styled(motion.div).attrs({
  variants: {
    hide: { opacity: 0, scale: 0.98, y: 10, transition: { duration: 0.2, type: 'tween' } },
    show: { opacity: 1, scale: 1, y: 0, transition: { duration: 0.15, type: 'tween' } }
  },
  initial: 'hide',
  animate: 'show',
  exit: 'hide'
})`
  z-index: 10000;
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.md}rem;
  width: max-content;
  max-width: min(100dvw, 21rem);
  padding: ${({ theme }) => theme.spacing.md}rem;
  background: ${({ theme }) => theme.colors.neutralWhite};
  border-radius: ${({ theme }) => theme.borderRadius.md}rem;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);
  outline: none !important;
`

export const CustomBlock = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.sm}rem;
`

export const CustomFields = styled.div`
  display: flex;
  gap: ${({ theme }) => theme.spacing.sm}rem;
`

export const CustomField = styled.label`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.xxxs}rem;
  flex: 1;
  min-width: 0;
  box-sizing: border-box;
  padding: ${({ theme }) => theme.spacing.xs}rem ${({ theme }) => theme.spacing.sm}rem;
  border: 1px solid ${({ theme }) => theme.colors.borderSoft};
  border-radius: ${({ theme }) => theme.borderRadius.sm}rem;
  background: ${({ theme }) => theme.colors.neutralWhite};
  font-family: inherit;
  text-align: left;
  cursor: text;

  &.isActive {
    border-color: ${({ theme }) => theme.colors.primary};
    background: ${({ theme }) => theme.dashboard.infoTint};
  }
`

export const CustomFieldLabel = styled.span`
  font-size: ${({ theme }) => theme.fontSize.px10}rem;
  font-weight: 600;
  color: ${({ theme }) => theme.colors.iconGray};
`

export const CustomFieldValue = styled.input`
  width: 100%;
  min-width: 0;
  padding: 0;
  border: none;
  background: transparent;
  font-family: inherit;
  font-size: ${({ theme }) => theme.fontSize.xs}rem;
  font-weight: 600;
  color: ${({ theme }) => theme.colors.menuBg};
  font-variant-numeric: tabular-nums;
  outline: none;

  &::placeholder {
    color: ${({ theme }) => theme.colors.iconGray};
    font-weight: 500;
  }
`

export const Footer = styled.div`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing.sm}rem;
  padding-top: ${({ theme }) => theme.spacing.sm}rem;
  border-top: 1px solid ${({ theme }) => theme.colors.neutralGray};
`

export const FooterDates = styled.span`
  flex: 1;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: ${({ theme }) => theme.fontSize.px11}rem;
  color: ${({ theme }) => theme.colors.iconGray};
  font-variant-numeric: tabular-nums;
`

const FooterAction = styled.button`
  border: none;
  background: transparent;
  font-family: inherit;
  font-size: ${({ theme }) => theme.fontSize.xs}rem;
  white-space: nowrap;
  cursor: pointer;
`

export const FooterClear = styled(FooterAction)`
  font-weight: 600;
  color: ${({ theme }) => theme.colors.iconGray};
`

export const FooterDone = styled(FooterAction)`
  font-weight: 700;
  color: ${({ theme }) => theme.colors.primary};

  &:disabled {
    opacity: 0.4;
    cursor: not-allowed;
  }
`
